import { CheckCircleOutlined } from "@ant-design/icons";
import { Button, Col, List, Row } from "antd";
import React, { useState, useEffect } from "react";
import HeroSectionRight from "./herosectionRight";

const heroSectionStyle = {
  textAlign: "center",
  // minHeight: "80vh",
  padding: "100px 110px 80px 110px",
  color: "#fff",
  // backgroundColor: "#108ee9",
  background: "linear-gradient(to left,rgb(229, 229, 229),rgb(70, 77, 96))",
};
const heroSectionMobileStyle = {
  textAlign: "center",
  // minHeight: "80vh",
  padding: "100px 110px 80px 110px",
  color: "#fff",
  // backgroundColor: "#108ee9",
  background: "linear-gradient(to left,rgb(222, 222, 222),rgb(70, 77, 96))",
};

function HeroSection() {
  const [paddingStyle, setPaddingStyle] = useState({
    padding: "100px 110px 100px 110px",
    minHeight: "60vh",
  });

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      
      if (mobile) {
        // Mobile view
        setPaddingStyle({
          padding: "50px 20px",
          minHeight: "auto",
        });
      } else if (window.innerWidth <= 1024) {
        // Tablet view
        setPaddingStyle({
          padding: "70px 40px",
          minHeight: "40vh",
        });
      } else {
        // Desktop view
        setPaddingStyle({
          padding: "100px 110px 80px 110px",
          minHeight: "60vh",
        });
      }
    };

    // Set initial padding based on current window size
    handleResize();

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    // <div style={{ ...heroSectionStyle, ...paddingStyle }}>
    <div style={{...(isMobile ? heroSectionMobileStyle : heroSectionStyle),...paddingStyle,}}>
      <Row gutter={[24, 24]} >
        <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ textAlign: "left", padding: isMobile ? "10px 1$0px" : "0" }}>
          <h2>Streamline Your Optical Business with Optix360</h2>
          <h2 style={{ fontSize: "35px", fontWeight: "bold", letterSpacing: "1px", lineHeight: "45px", display: window.innerWidth <= 768 ? 'none' : 'block' }}>
            Start simplifying your store today — the smart way with Optix360.
          </h2>
          <p style={{ fontSize: "16px", color: "#fff", lineHeight: "24px", display: window.innerWidth <= 768 ? 'none' : 'block' }}>
            Optix360 is Pakistan’s leading cloud-based solution tailored for optical businesses. From managing customer records and sales to handling inventory, billing, and online orders — Optix360 brings all your operations into one powerful platform. Stay organized, improve efficiency, and grow your business with confidence.
          </p>
          {isMobile && (

          <p style={{ fontSize: "16px", color: "#fff", lineHeight: "24px" }}>
            Run your optical store smarter with Optix360 — the all-in-one cloud solution for sales, inventory, and customer management.
          </p>
          )}
          <List
            style={{ border: "none", color: "#fff", marginBottom: "20px" }}
            renderItem={(item) => (
              <List.Item style={{ border: "none", padding: "8px 0", color: "#fff", fontSize: "16px" }}>
                <CheckCircleOutlined style={{ color: "#fff", marginRight: 10 }} />
                {item}
              </List.Item>
            )}
            dataSource={["No hidden fees, Start with a free account", "Customer Records", "POS Operations", "Inventory Management", "Online Store Integration", "Safe and Secure"]}
          />
          <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
            <Button type="primary" size="large" style={{ backgroundColor: "#fff", color: "#000", marginRight: "10px", padding: 25 }} onClick={() => window.location.href = "https://optix360-app.mayaartech.com/login"}>Get Started</Button>
            <Button type="primary" style={{ padding: 25 }} size="large" onClick={() => window.location.href = "https://optix360-app.mayaartech.com/login"}>Get Free Trial</Button>
          </div>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <HeroSectionRight />
        </Col>
      </Row>
    </div>
  );
}

export default HeroSection;